import { MVTLayer } from '@deck.gl/geo-layers'
import { type MVTLayerProps } from '@deck.gl/geo-layers/typed/mvt-layer/mvt-layer'
import { FeatureType } from 'stores/features'

class VegetationSimulationLayer extends MVTLayer {
  constructor(props: MVTLayerProps) {
    super({
      maxCacheSize: 100000000,
      maxRequests: 5,
      opacity: 1,
      material: false,
      ...props
    })
  }

  get type() {
    return FeatureType.Vegetation
  }

  initializeState(params) {
    super.initializeState(params)
  }

  finalizeState() {
    super.finalizeState()
  }
}

export default VegetationSimulationLayer
